import {
  ChangeDetectorRef,
  Directive, ElementRef, Input, Optional, TemplateRef,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line
  selector: '[gas-tab], gasTab',
  exportAs: 'gasTab',
})
export class GasTabDirective {
  /** Название таба */
  @Input()
  public title: string;

  public templateLabel: TemplateRef<ElementRef>;

  constructor(
    @Optional() public templateRef: TemplateRef<ElementRef>,
    public changeDetectorRef: ChangeDetectorRef,
  ) {
  }
}
